<template>
  <div class="slides">
    <v-sheet
      width="100%"
      color="transparent"
      class="d-flex align-center justify-center slides-logo"
    >
      <img
        v-if="informations.img_brand"
        :src="files + informations.img_brand"
        :alt="informations.name"
        class="ma-3 mx-md-5 my-md-7 d-block"
        height="104px"
      />

      <a
        class="d-block ma-3 mx-md-5 my-md-7"
        href="//hospitaldoispinheiros.com.br"
        target="_blank"
      >
        <img
          src="../../assets/img/hospital-dois-pinheiros.png"
          class="d-block filter-white"
          height="82px"
        />
      </a>
    </v-sheet>

    <hooper
      style="height: auto"
      ref="carousel"
      :wheelControl="false"
      infiniteScroll
      v-if="items.length"
    >
      <slide
        class="slides-item"
        v-for="({ img_desktop, img_mobile, link, target }, keySlide) in items"
        :key="keySlide"
      >
        <a v-if="link" :href="link" :target="target ? '_blank' : '_self'">
          <img
            :src="files + (smAndDown && img_mobile ? img_mobile : img_desktop)"
            class="d-block slides-item-img"
            width="100%"
          />
        </a>

        <img
          v-else
          :src="files + (smAndDown && img_mobile ? img_mobile : img_desktop)"
          class="d-block slides-item-img"
          width="100%"
        />
      </slide>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

const _config = {
  mod: "slidesAngels",
};

export default {
  created() {
    this.$rest(_config.mod).get();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    informations() {
      return this.$rest("informationsAngels").item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Hooper,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.slides {
  &-logo {
    position: absolute;
    top: 0;
    z-index: 10;

    > img {
      max-width: 40%;
      object-fit: contain;
      -o-object-fit: contain;
    }

    > a {
      display: block;
      max-width: 40%;

      > img {
        width: 100%;
        object-fit: contain;
        -o-object-fit: contain;
      }
    }
  }
}

.slides::v-deep {
  .slides-item {
    .slides-item-img {
      aspect-ratio: 1920 / 780;
      // min-height: 480px;
      object-fit: cover;
      -o-object-fit: cover;

      @media screen and (max-width: 960px) {
        aspect-ratio: 1 / 1;
      }
    }
  }
}
</style>
